import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { CBcPrivilegeTree, CBcPrivilegeGroup, } from '@/classes/BcClasses';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
let AppPrivileges = class AppPrivileges extends Vue {
    constructor() {
        super();
        this.treeModel = [];
        this.treeActive = [];
        this.treeOpen = [];
        this.listP = [];
        this.currentPrivilege = null;
        this.prisGroupTree = []; // for display
        this.privilegesLoading = false;
        this.currentPrivilegesLoading = false;
        this.formValid = false;
        this.showChoose = false;
        this.pageLoading = false;
        this.tableLoading = false;
        this.dataHandleLoading = false;
        this.tableOptions = {
            visible: false,
            pageSize: 10,
            page: 1,
            total: 1,
            expanded: []
        };
        this.snackbar = new CBcSnackbar();
        this.dialog = {
            editor: -1,
            title: '',
            text: '',
            visible: false,
            loading: false,
            detail: false,
            status: false,
        };
        this.searchOptions = {
            appName: '',
            appId: '',
            appKey: null,
            appSecret: null,
            description: null,
            quickly: ''
        };
        this.list = [];
        this.headers = [
            { text: '应用名称', align: 'center', width: 120, value: 'appName' },
            { text: '应用 id', align: 'center', width: 120, value: 'appId' },
            { text: 'appKey', align: 'center', width: 100, value: 'appKey' },
            { text: 'appSecret', align: 'center', width: 100, value: 'appSecret' },
            { text: '应用描述', align: 'center', width: 110, value: 'description' },
            { text: '配置权限', align: 'center', width: 110, value: 'privilege' },
        ];
        this.formData = {};
        // 用于存储每个条目的显示状态
        this.visibilityState = new Map();
        const that = this;
    }
    async mounted() {
        const that = this;
        that.getList();
        that.getListP();
        // that.pageRefresh()
    }
    onTreeActiveChanged(v, o) {
        const that = this;
        if (v === o && !v.length)
            return;
        that.currentPrivilege = v[0];
    }
    onTreeOpenChanged(v) {
        console.log('tree open:', v);
    }
    // 刷新弹框
    // pageRefresh() {
    //   const that: any = this;
    //   that.treeModel = null
    //   that.getListP()
    // }
    // 刷新列表
    refresh() {
        location.reload();
    }
    getList() {
        const that = this;
        that.tableLoading = true;
        try {
            // 获取当前登陆用户的应用列表
            const ret = that.axios.get('/api/apps/user')
                .then((res) => {
                that.list = (res && res.data && res.data.result || []).map((v) => {
                    v['appName'] = v.name;
                    v['appId'] = v.id;
                    v['appKey'] = v.appKey;
                    v['appSecret'] = v.appSecret;
                    v['description'] = v.description;
                    v['privilege'] = v.privilege;
                    return v;
                });
                that.tableOptions.total = res && res.data && res.data.sum || that.list.length;
                return res;
            });
            that.tableLoading = false;
            return ret;
        }
        catch (e) {
            that.tableLoading = false;
            that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    async getListP() {
        const that = this;
        that.privilegesLoading = true;
        try {
            const res = (await that.axios.get('/api/privileges', { params: { type: 'operation' } })).data;
            that.listP = res.result || [];
            // 扩展权限列表：支持GET方法的原有权限 + 新增的POST同步接口权限
            const result = that.listP.filter((v) => {
                const method = v.info && v.info.method;
                const url = v.info && v.info.url;
                // 原有GET权限
                const isAllowedGet = /get/i.test(method) && /^hospital$|^report\/malfunction\/summary$|^recipels\/manual\/dailyreport$|^report\/dispense\/summary$|^report\/dispense\/device\/summary$|^report\/device\/mode\/summary$|^report\/dispense\/summary$|^report\/dispense\/device\/summary$|^report\/device\/mode\/summary$|^recipels\/manual$/i.test(url);
                // 新增的POST同步接口权限（配药记录与故障记录离线上传）
                const isAllowedPost = /post/i.test(method) && /^device\/sync\/malfunction$|^device\/sync\/recipel$/i.test(url);
                // 新增的GET设备信息接口权限
                const isAllowedDeviceGet = /get/i.test(method) && /^device$/i.test(url);
                return isAllowedGet || isAllowedPost || isAllowedDeviceGet;
            });
            that.prisGroup = new CBcPrivilegeGroup(result);
            // console.log('data:', that.prisGroup)
            that.prisGroupTree = [
                new CBcPrivilegeTree({ id: 'root1', name: '所有权限', children: that.prisGroup.datas })
            ];
            that.privilegesLoading = false;
        }
        catch (e) {
            that.privilegesLoading = false;
            console.log('error to load privileges:', e);
            that.snackbar.error('数据加载失败');
        }
    }
    async updatePrivileges() {
        const that = this;
        try {
            const res = await that.axios.post('/api/apps/access/', {
                appId: that.changeAppId,
                privileges: that.treeModel.map((v) => v.id)
            });
            if (res.data && res.data.errorCode === -4003) {
                that.snackbar.error('权限不足，仅管理员账号才能设置应用权限');
            }
            else {
                that.snackbar.success('应用权限授权成功');
            }
        }
        catch (e) {
            console.log('update  privileges error:', e);
            if (e && e.errorCode === -4003) {
                that.snackbar.error('权限不足，仅管理员账号才能设置应用权限');
            }
            else {
                that.snackbar.error('应用权限授权失败:' + (e && (e.result || e.info || e.error)));
            }
        }
        that.dialog.title = 'exit';
        that.showChoose = false;
    }
    createNew() {
        const that = this;
        that.dialog.detail = false;
        that.dialog.editor = 1;
        that.dialog.title = '创建应用';
        that.dialog.visible = true;
    }
    editItem(iItem, type) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.editFormPanels = [];
        that.dialog.editor = 2;
        that.dialog.detail = false;
        that.dialog.title = '修改应用';
        that.dialog.text = '';
        that.formData = item;
        that.formData.deviceId = that.listDevice.find((v) => v.id === item.deviceId);
        that.dialog.visible = true;
    }
    deleteItem(iItem) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.dialog.editor = 3;
        that.dialog.detail = false;
        that.dialog.title = '应用删除';
        that.dialog.text = '是否删除当前应用，删除后将移至配置记录回收站.';
        that.formValid = true;
        that.formData = item;
        that.formData.deviceId = that.listDevice.find((v) => v.id === item.deviceId);
        that.dialog.visible = true;
    }
    // 授权
    chooseItem(iItem, type) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.changeAppId = item.appId;
        that.dialog.title = '修改权限';
        that.getAppPrivileges(item.appId);
        that.showChoose = true;
    }
    async createNewHandle() {
        const that = this;
        console.log('params:', '= name:' + that.formData.name + 'description:' + that.formData.description + 'type:' + that.formData.type);
        const ret = that.axios.post('/api/apps', {
            name: that.formData.name,
            description: that.formData.description,
            type: that.formData.type
        })
            .then((res) => {
            console.log('创建应用', res);
        });
        return ret;
    }
    editItemHandle() {
        const that = this;
        const form = JSON.parse(JSON.stringify(that.formData));
        const body = form;
        if (/object/i.test(typeof body['deviceId']))
            body['deviceId'] = body['deviceId'].id;
    }
    deleteItemHandle() {
        const that = this;
    }
    closeShowChoose() {
        const that = this;
        that.dialog.title = 'exit';
        that.showChoose = false;
    }
    close() {
        const that = this;
        that.dialog.visible = false;
    }
    async save() {
        const that = this;
        const typeName = (that.dialog.editor === 1 ? '新增' : that.dialog.editor === 2 ? '修改' : '删除') + '应用';
        that.dataHandleLoading = true;
        try {
            switch (that.dialog.editor) {
                case 1:
                    await that.createNewHandle();
                    break;
                case 2:
                    await that.editItemHandle();
                    break;
                case 3:
                    await that.deleteItemHandle();
                    break;
                default:
                    break;
            }
            that.dataHandleLoading = false;
            that.dialog.visible = false;
            that.getList();
            that.snackbar.success(`${typeName}成功`);
        }
        catch (e) {
            console.log('handle result error:', e);
            that.dataHandleLoading = false;
            if (that.dialog.editor === 3)
                that.dialog.visible = false;
            that.snackbar.error(e && (e.info || e.error || e.errorInfo || e.result || e.toString()) || `${typeName}失败`);
        }
    }
    paginationHandle() {
        const that = this;
        const ps = Number.isNaN(parseInt(that.tableOptions.pageSize, 10)) ? that.tableOptions.total : that.tableOptions.pageSize;
        if (that.tableOptions.page > Math.ceil(that.tableOptions.total / ps))
            that.tableOptions.page = 1;
        that.getList();
    }
    getAppPrivileges(id) {
        const that = this;
        that.currentPrivilegesLoading = true;
        that.axios.get('/api/apps/access', { params: { appId: id } }).then((res) => {
            // that.treeActive = (res.data && res.data.result || []).map((v: any) => v.appPrivilegeInfo && v.appPrivilegeInfo.typeId)
            const typesid = (res.data && res.data.result || []).map((v) => v.appPrivilegeInfo && v.appPrivilegeInfo.id);
            // eslint-disable-next-line eqeqeq
            that.treeModel = that.prisGroup.datas.filter((v) => typesid.find((fv) => fv == v.id));
            that.currentPrivilegesLoading = false;
        }).catch((e) => {
            that.currentPrivilegesLoading = false;
            console.log('error to get apps access privileges:', e);
        });
    }
    /**
     * 判断指定字段是否可见
     */
    isVisible(item, field) {
        const key = `${field}_${item.id || item.appId}`;
        return this.visibilityState.get(key) || false;
    }
    /**
     * 切换显示/隐藏状态
     */
    toggleVisibility(item, field) {
        const key = `${field}_${item.id || item.appId}`;
        const current = this.visibilityState.get(key) || false;
        this.visibilityState.set(key, !current);
        // 强制 Vue 响应式更新
        this.visibilityState = new Map(this.visibilityState);
    }
    /**
     * 掩码显示值（默认显示为*号）
     */
    maskValue(value) {
        if (!value)
            return '';
        // 只显示前 4 位和后 4 位，中间用*号代替
        if (value.length <= 8) {
            return '*'.repeat(value.length);
        }
        return value.substring(0, 4) + '*'.repeat(value.length - 8) + value.substring(value.length - 4);
    }
    /**
     * 复制到剪贴板
     * 优先使用 Clipboard API（需要 HTTPS），不支持时使用 fallback 方案
     */
    async copyToClipboard(text, field) {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
            }
            else {
                this.fallbackCopyToClipboard(text);
            }
            this.snackbar.success(`${field === 'appKey' ? 'appKey' : 'appSecret'} 已复制到剪贴板`);
        }
        catch (err) {
            console.error('复制失败:', err);
            this.snackbar.error('复制失败，请手动复制');
        }
    }
    /**
     * fallback 复制方法（兼容非 HTTPS 环境）
     */
    fallbackCopyToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            const successful = document.execCommand('copy');
            if (!successful) {
                throw new Error('execCommand copy failed');
            }
        }
        finally {
            document.body.removeChild(textArea);
        }
    }
};
__decorate([
    Watch('treeActive')
], AppPrivileges.prototype, "onTreeActiveChanged", null);
__decorate([
    Watch('treeOpen')
], AppPrivileges.prototype, "onTreeOpenChanged", null);
__decorate([
    Watch('tableOptions.pageSize'),
    Watch('tableOptions.page')
], AppPrivileges.prototype, "paginationHandle", null);
AppPrivileges = __decorate([
    Component({
        components: {
            BcSnackbar,
        }
    })
], AppPrivileges);
export default AppPrivileges;
;
